<!--顶部工具栏组件-->
<template>
  <v-toolbar id="core-toolbar" class="toolbar">
    <div class="head" style="width:60%">
      <div class="logo">
        <img src="@/assets/bayer-logo.svg" />
      </div>
      <div class="logo-title">Smart Label Recognition</div>
    </div>

    <v-spacer />

    <div style="margin-right: 20px;">
      <span class="user-cell">{{ userName }}</span>
    </div>

    <v-toolbar-items>
      <v-flex align-center layout py-3>
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition"
        >
          <router-link
            v-ripple
            slot="activator"
            class="toolbar-items"
            to="/index"
          >
            <v-badge color="error" overlap>
              <v-icon style="color:white;">mdi-view-dashboard</v-icon>
            </v-badge>
          </router-link>
        </v-menu>
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition"
          style="width:20px;"
        >
        </v-menu>
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition"
        >
          <router-link v-ripple slot="activator" class="toolbar-items" to>
            <v-badge color="error" overlap>
              <v-icon style="color:white;">mdi-power-standby</v-icon>
            </v-badge>
          </router-link>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="notification in UserSettings"
                :key="notification.name"
              >
                <a @click="logoff()">{{ notification.title }}</a>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>
<style>
.user-cell {
  color: white;
  font-size: 16px;
}
</style>
<script>
import { mapMutations, mapState } from 'vuex'
import { post } from '@/request/http'
export default {
  data() {
    return {
      title: null,
      text: 'center',
      Users: ['张三(S005300)'],
      user: '张三(S005300)',
      url: process.env.VUE_APP_TOKEN_API + '/token/logoff/'
    }
  },
  computed: {
    notifications() {
      return [
        {
          title: this.$t('toolbar.newEvent'),
          path: 'index',
          icon: 'mdi-plus-box'
        },
        {
          title: this.$t('toolbar.newHCP'),
          path: 'hcpmain',
          icon: 'mdi-plus-box'
        }
      ]
    },
    UserSettings() {
      return [{ title: this.$t('loginout'), path: '/' }]
    },
    ...mapState({
      base: state => state.base
    }),
    userName() {
      let logininfo = JSON.parse(localStorage.getItem('loginuser'))
      return logininfo && logininfo.Name
    }
  },
  watch: {
    $route(val) {
      this.title = val.name
    }
  },
  methods: {
    logoff() {
      let param = {
        userName: this.base.loginuser.userName,
        t: new Date().getTime()
      }
      post(this.url, param)
      this.base.loginuser = {
        Roles: [],
        password: null,
        userName: null,
        token: null
      }
      localStorage.removeItem('loginuser')
      this.$router.push('/')
    },
    ...mapMutations('base', ['setDrawer', 'toggleDrawer']),
    onClickBtn() {
      this.setDrawer(!this.$store.state.base.drawer)
    },
    onClick() {
      //
    }
  }
}
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
.v-toolbar {
  box-shadow: none !important;
  z-index: 4;
}
.v-toolbar__content {
  height: 72px !important;
}
.notification-icon {
  color: '#43A047';
  padding-right: 10px;
}
</style>

<i18n>
{
    "en": {

        "loginout": " Log off"
     
  },
    "cn": {
  
        
        "loginout": "退出"
      }
  }
</i18n>
